import './navbar.css';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Add or remove the event listener when the menu state changes
  useEffect(() => {
    function handleClickOutside(event) {
      // Check if the click happened outside the dropdown
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.closest('.hamburger')
      ) {
        setIsOpen(false); // Close the menu
      }
    }

    // Add the event listener
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="nav-brand">Journaly</div>

      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Dropdown menu */}
      <div className={`nav-menu ${isOpen ? 'active' : ''}`} ref={menuRef}>
        <Link to="/" className="nav-item">
          Rate My Day
        </Link>
        <Link to="/table2" className="nav-item">
          Social Rating
        </Link>
        <Link to="/table3" className="nav-item">
          Weather Table
        </Link>
        <Link to="/highlight-of-the-day" className="nav-item">
          Highlight of the Day
        </Link>
        <Link to="/challenge" className="nav-item">
          Monthly Challenge
        </Link>
        <Link to="/about" className="nav-item">
          About
        </Link>
      </div>
    </nav>
  );
}
